<template>
  <div class="animate-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="位置尺寸" name="1">
          <div class="setting-item clearFloat mb16">
            <widthAndSizeAndZindex :options="options" :ids="ids" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"

export default {
  name: "text-options-data",
  components: { widthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      this1: this,
      activeType: 1,
      sliderMax: 360
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
</style>
